import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Field, Form } from "react-final-form";
import InputField from "../../General-UI/InputField";
import { MAX_NAME_LENGTH } from "constants/constants";
import {
  selectTryingRegister,
  selectUserResetError,
  sendResetPasswordEmail,
} from "slices/authSlice";
import { selectForgottenPasswordModal } from "slices/signInPageSlice";

const validate = (formValues) => {
  const errors = {};

  if (!formValues.email) {
    errors.email = "No email entered";
  } else if (formValues.email.length > MAX_NAME_LENGTH) {
    errors.email =
      "Email too long (>" + MAX_NAME_LENGTH.toString() + " letters)";
  }

  return errors;
};

const ForgotPasswordEmail = () => {
  const tryingRegister = useSelector(selectTryingRegister);
  const userResetError = useSelector(selectUserResetError);
  const forgottenPasswordModal = useSelector(selectForgottenPasswordModal);
  const dispatch = useDispatch();

  return (
    <div className="inline-form">
      <Form
        onSubmit={(formValues) => {
          dispatch(sendResetPasswordEmail(formValues.email));
        }}
        validate={validate}
        render={({ handleSubmit, form }) => {
          if (!forgottenPasswordModal) {
            form.restart();
          }
          return (
            <form onSubmit={handleSubmit}>
              <div className="modal-text">
                Enter your account email address and a verification code will be
                sent to your inbox. This code will be used to reset your
                password.
              </div>
              <br />
              <div>
                <Field
                  name="email"
                  type="email"
                  component={InputField}
                  placeholder="Email address"
                  className="input-box"
                />
              </div>
              <button
                onClick={handleSubmit}
                type="submit"
                className="confirm-button business-button"
                disabled={tryingRegister}
              >
                {tryingRegister ? "Sending..." : "Send Code"}
              </button>
              <div className="server-response-error">
                {userResetError ? userResetError.message : null}
              </div>
            </form>
          );
        }}
      />
    </div>
  );
};

export default ForgotPasswordEmail;
